import { render } from "./AppMain.vue?vue&type=template&id=2c6d834c&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"

import "./AppMain.vue?vue&type=style&index=0&id=2c6d834c&scoped=true&lang=css"
import "./AppMain.vue?vue&type=style&index=1&id=2c6d834c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6d834c"]])

export default __exports__